<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="协议编码:" label-width="100px">
                <el-input size="small" v-model="dataForm.priceAgreementCode" placeholder="协议编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="合同编号:" label-width="100px">
                <el-input size="small" v-model="dataForm.contractCode" placeholder="合同编号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="采购组织:" label-width="110px">
                <el-select size="small" v-model="dataForm.purchasePartya" placeholder="请选择" clearable @change="getDataList">
                    <el-option v-for="(item,index) in purchasePartyAList" :key="index" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工厂:" label-width="80px">
                <el-select v-model="dataForm.factory" filterable clearable placeholder="请选择" @change="getDataList">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                    </el-option>
                </el-select>
                 <!-- <el-input size="small" v-model="dataForm.factory" placeholder="请输入工厂" clearable @blur="getDataList"></el-input> -->
            </el-form-item>
            <el-form-item label="采购组:" label-width="100px">
                <el-select size="small" v-model="dataForm.procurementGroup" placeholder="请选择" clearable @change="getDataList">
                    <el-option v-for="(item,index) in procurementList" :key="index" :label="item.positionCode+':'+item.realName" :value="item.positionCode">
                    </el-option>
                </el-select>
                <!-- <el-input size="small" v-model="dataForm.procurementGroup" placeholder="请输入采购组代码" clearable @blur="getDataList"></el-input> -->
            </el-form-item>
            <el-form-item label="是否同步:" label-width="100px">
                <el-select size="small" v-model="dataForm.syncStatus" placeholder="请选择" clearable @change="getDataList">
                    <el-option v-for="(item,index) in SYNC_STATUS_PRICE" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商编码:" label-width="110px">
                <el-input size="small" v-model="dataForm.partybCode" placeholder="请输入供应商编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料号:" label-width="80px">
                <el-input size="small" v-model="dataForm.partCode" placeholder="请输入物料号" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="物料名称:" label-width="80px">
                <el-input size="small" v-model="dataForm.partName" placeholder="请输入物料名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="截止日区间:" label-width="100px">
                <el-date-picker v-model="dataForm.deadlineDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="queryHandle()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" plain type="primary" @click="exportPriceAgreementData()">
                    批量导出
                </el-button>
                <el-button size="small" plain v-if="isAuth('sourcing:priceAgreementImport:importButton')" type="primary" @click="importTemplate()">
                    批量导入
                </el-button>
                <el-button size="small" plain v-if="isAuth('sourcing:priceAgreementImport:sendSAP')" type="warning" @click="pushSaps()" icon="el-icon-plus">
                    批量推送SAP
                </el-button>
                <el-button size="small" plain v-if="isAuth('sourcing:priceAgreementImport:deleteList')" type="warning" @click="deleteList()" icon="el-icon-delete">
                    批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" :data="dataList" :row-class-name="tableRowClassName" @selection-change="selectionChangeHandle" size="small" bPriceAgreement style="width: 100%;" :default-expand-all="false" border :height="tableHeight">
                <el-table-column type="selection" :selectable='checkboxSelect' width="55">
                </el-table-column>
                <el-table-column v-if='false' prop="zguid" header-align="center" align="left" label="32位唯一标识" width="150">
                </el-table-column>
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="choose" header-align="center" align="center" label="操作类型" width="80">
                 </el-table-column> -->
                <el-table-column prop="syncStatus" header-align="center" align="left" label="同步状态" width="100">
                     <template slot-scope="scope">
                         <span :class="getStatusClass(scope.row.syncStatus)">{{getSyncStatus(scope.row.syncStatus)}}</span>
                     </template>
                </el-table-column>
                <el-table-column prop="priceAgreementCode" header-align="center" align="left" label="协议编码" width="160">
                </el-table-column>
                <el-table-column prop="agreementStatus" header-align="center" align="center" label="协议状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.agreementStatus)">
                            {{ agreementStatusFormat(scope.row.agreementStatus) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="contractCode" header-align="center" align="center" label="合同编号" width="120">
                </el-table-column>
                <el-table-column prop="createByName" header-align="center" align="left" label="导入者" width="100">
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="left" label="导入时间" width="100" :formatter="dateFormat">
                 </el-table-column>
                <el-table-column prop="factory" header-align="center" align="left" label="工厂" width="80">
                </el-table-column>
                <el-table-column prop="partybCode" header-align="center" align="center" label="供应商编码" width="100">
                    <template slot-scope="scope">
                        <!-- 悬浮提示 -->
                        <el-tooltip placement="top" effect="light">
                            <!-- 供应商名称 -->
                            <div slot="content">{{scope.row.supplierPartyb}}</div>
                            <span>{{scope.row.partybCode}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="物料号" width="120">
                    <template slot-scope="scope">
                        <!-- 悬浮提示 -->
                        <el-tooltip placement="top" effect="light">
                            <!-- 供应商名称 -->
                            <div slot="content">{{scope.row.partName}}</div>
                            <span>{{scope.row.partCode}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="物料名称" width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.partName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="provisionalEstimate" header-align="center" align="center" label="是否暂估" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.row.provisionalEstimate}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sharePriceWithoutTax" header-align="center" align="right" label="净价" width="100">
                </el-table-column>
                <el-table-column prop="sharePriceWithoutTaxSap" header-align="center" align="right" label="SAP净价" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.sharePriceWithoutTaxSap}}
                    </template>
                </el-table-column>
                <el-table-column prop="peinh" header-align="center" align="center" label="价格单位" width="50">
                </el-table-column>
                <el-table-column prop="contractStartDate" header-align="center" align="left" label="开始生效日期" width="100" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="contractEndDate" header-align="center" align="left" label="有效截止日期" width="100" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="purchasePartya" header-align="center" align="left" label="采购组织" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.purchasePartya}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="procurementGroup" header-align="center" align="left" label="采购组" width="100">
                     <template slot-scope="scope">
                         <span>{{scope.row.procurementGroup}}:{{getProcurementName(scope.row.procurementGroup)}}</span>
                     </template>
                </el-table-column>
                <el-table-column prop="esokz" header-align="center" align="center" label="采购信息记录分类" width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.esokz}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" header-align="center" align="center" label="采购单位" width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.unit}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taxRate" header-align="center" align="center" label="税码" width="80">
                     <template slot-scope="scope">
                         <span>{{scope.row.taxRate}}</span>
                     </template>
                </el-table-column>
                <el-table-column prop="currency" header-align="center" align="center" label="币别" width="80">
                </el-table-column>
                <el-table-column prop="partybRepresentive" header-align="center" align="center" label="责任销售员" width="100">
                </el-table-column>
                <el-table-column prop="supplierTelNumber" header-align="center" align="left" label="供应商电话号码" width="150">
                </el-table-column>
                <el-table-column prop="aplfz" header-align="center" align="center" label="计划交货天数" width="100">
                </el-table-column>
                <el-table-column prop="factoryName" header-align="center" align="left" label="工厂名称" width="280">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.factory)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="purchasePartya" header-align="center" align="left" label="采购组织名称" width="280">
                    <template slot-scope="scope">
                        <span>{{getPurchaseOrgName(scope.row.purchasePartya)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="conversionMolecule" header-align="center" align="left" label="转换分子" width="100">
                </el-table-column>
                <el-table-column prop="conversionDenominator" header-align="center" align="left" label="转换分母" width="100">
                </el-table-column>
                <el-table-column prop="kmein" header-align="center" align="left" label="板材结算单位" width="100">
                </el-table-column>
                <el-table-column prop="transactionMessage" header-align="center" align="left" label="同步结果信息" width="250">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.syncStatus == 1 || scope.row.choose == 'U'? true : false || strStart(scope.row.priceAgreementCode) == 0 || (strStart(scope.row.priceAgreementCode) < 0 && isDisabled(scope.row.createByName))" type="text" size="small" v-if="isAuth('sourcing:priceAgreementImport:update')"  @click="updateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button :disabled="scope.row.syncStatus == 1 || scope.row.choose == 'U'? true : false || strStart(scope.row.priceAgreementCode) == 0 || (strStart(scope.row.priceAgreementCode) < 0 && isDisabled(scope.row.createByName))" v-if="isAuth('sourcing:priceAgreementImport:delete')" type="text" size="small" @click="deleteHandle(scope.row.partId)" icon="el-icon-delete">
                            删除
                        </el-button>
                        <el-button :disabled="scope.row.syncStatus == 1 || scope.row.choose == 'U'? true : false || (strStart(scope.row.priceAgreementCode) == 0 && scope.row.agreementStatus != '流程结束')|| scope.row.syncing"
                                   type="text"
                                   v-if="isAuth('sourcing:priceAgreementImport:push')"
                                   size="small"
                                   @click="pushSap(scope.row)"
                                   icon="el-icon-edit">
                            同步
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <updateAgreement v-if="updateVisible" ref="updateAgreement" @refreshDataList="getDataList"></updateAgreement>
        <price-agreement-import v-if="priceAgreementImportVisible"  @refreshDataList="getDataList" ref="priceAgreementImport"></price-agreement-import>
    </div>
</div>
</template>

<script>
import {
    getPurchaseOrgList,
    getFactoryList,
    getTaxCodeList
} from '@/controller/systemData'
import {
    getPriceAgreementListPage,
    pushSapBack,
    exportPriceAgreement,
    deletePriceAgreementById,
    deleteListBack
} from '@/controller/priceAgreement'
import {
    SYNC_STATUS_PRICE,
    getPURCHASE_MESSAGE_TYPE_VALUE,
    getUnitValue,
    getKosrtByValue,
    AGREEMENT_STATUS,
    getLabelByValue,
} from '@/utils/const'
import {
    getSysPositionList
} from '@/controller/sys'
import {getUserInfoByToken} from '@/controller/sys'
import moment, { now } from 'moment'
import PriceAgreementImport from './price-agreement-import'
import UpdateAgreement from './price-agreement-update'
// require('@/mock/mockPriceAgreement');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 270,
            priceAgreementImportVisible:false,
            updateVisible:false,
            purchasePartyAList: [],//采购组织数据集合
            factoryList:[],//工厂数据集合
            getPURCHASE_MESSAGE_TYPE_VALUE: getPURCHASE_MESSAGE_TYPE_VALUE,//采购记录信息取对应value
            getUnitValue:getUnitValue,//采购单位获取对应的value
            getKosrtByValue:getKosrtByValue,//是否暂估
            dataForm: {
                priceAgreementCode: '',//SRM供应商编码
                purchasePartya:'',//采购组织
                partCode:'',//物料号
                factory:'',//工厂
                partybCode: '',//供应商编码
                esokz: '',//采购记录分类
                syncStatus:'',//是否同步
                procurementGroup:'',//采购组
                deadlineDate:'',//截至日区间
                contractCode:'',
                partName:'',
            },
            dataList: [],
            taxCodeList: [],
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            // 同步状态
            SYNC_STATUS_PRICE: SYNC_STATUS_PRICE,
            dataListLoading: false,
            dataListSelections: [],//多选的row
            procurementList:[],//采购组集合
            userRealName: '',
            AGREEMENT_STATUS: AGREEMENT_STATUS,
        }
            
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 310
            }
        }
    },
    components: {
        PriceAgreementImport,
        UpdateAgreement
    },
    activated() {
        this.getUserInfo()
        this.getPurchaseOrgListVue()
        this.getFactoryListVue()
        this.getTaxCodeListVue()
        this.getSysPositionListVue()
    },
    methods: {
        // 获取当前登录人员信息
        getUserInfo() {
            getUserInfoByToken({}).then(data => {
                if (data && data.code === '00') {
                    this.userRealName = data.body.user.realName
                    this.getDataList();
                }
            })
        },
        isDisabled(val) {
            if(val === this.userRealName) {
                return false
            } else {
                return true
            }
        },
        // 采购组织数据
        getPurchaseOrgListVue() {
            getPurchaseOrgList({
                purchaseOrgCode: '',
                purchaseOrgName: '',
            }).then((data) => {
                if (data && data.code === '00') {
                this.purchasePartyAList = data.body
                }
            })
        },
        // 采购组数据
        getSysPositionListVue() {
            getSysPositionList().then((data) => {
                if (data && data.code === '00') {
                this.procurementList = data.body
                }
            })
        },
        //获取工厂的数据
        getFactoryListVue() {
            getFactoryList({
                post: '',
                address: '',
                factoryDesc: '',
                factoryCode: '',
            }).then((data) => {
                if (data && data.code === '00') {
                    this.factoryList = data.body
                }
            })
        },
        //禁用checkbox
        checkboxSelect (row, rowIndex) {
            if (row.syncStatus == 1) {
                return false // 禁用
            }else{
                return true // 不禁用
            }
        },
        //日期格式化
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 查询按钮
        queryHandle() {
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            getPriceAgreementListPage({
                pageSize: this.pageSize,
                pageNo: this.pageIndex,
                'priceAgreementCode': this.dataForm.priceAgreementCode,//SRM协议号
                'purchasePartya': this.dataForm.purchasePartya,//采购组织
                'partCode': this.dataForm.partCode,//物料号
                'factory': this.dataForm.factory,//工厂
                'partybCode': this.dataForm.partybCode,//供应商编码
                'esokz': this.dataForm.esokz,//采购记录分类
                'syncStatus': this.dataForm.syncStatus,//是否同步
                'procurementGroup': this.dataForm.procurementGroup,//采购组
                'contractCode': this.dataForm.contractCode,//合同编号
                'partName': this.dataForm.partName,
                'deadlineDateStart': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'deadlineDateEnd': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1]//截止日区间结束
            }).then(data => {
                if (data && data.code === '00') {
                    // this.dataList = data.body.records
                    this.dataList = data.body.records.map(record => ({
                      ...record,
                      syncing: false // 设置 syncing 为 false
                    }));
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        //批量导入
        importTemplate() {
            this.priceAgreementImportVisible = true
            this.$nextTick(() => {
                this.$refs.priceAgreementImport.init()
            })
        },
        //查询条件导出
        exportPriceAgreementData(){
            if(this.dataForm.priceAgreementCode === ''
                && this.dataForm.purchasePartya === ''
                && this.dataForm.partCode === ''
                && this.dataForm.factory === ''
                && this.dataForm.partybCode === ''
                && this.dataForm.syncStatus === ''
                && this.dataForm.procurementGroup === ''){
                 this.$message.error('请输入查询条件导出')
                 return
            }
            const params = {
                'priceAgreementCode': this.dataForm.priceAgreementCode,//SRM协议号
                'purchasePartya': this.dataForm.purchasePartya,//采购组织
                'partCode': this.dataForm.partCode,//物料号
                'factory': this.dataForm.factory,//工厂
                'partybCode': this.dataForm.partybCode,//供应商编码
                'syncStatus': this.dataForm.syncStatus,//是否同步
                'procurementGroup': this.dataForm.procurementGroup,//采购组
                'deadlineDateStart': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'deadlineDateEnd': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1]//截止日区间结束
            }
            exportPriceAgreement(params).then((data) => {
                if(data && data.code == '00') {
                    this.readAsBinaryString(data.body)
                    this.$message.success({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        //通过采购组织code 获取采购组织名称
        getPurchaseOrgName(code) {
            const purchaseOrg = this.purchasePartyAList.find(
                (purchaseOrg) => purchaseOrg.purchaseOrgCode === code
        )
        return purchaseOrg ? purchaseOrg.purchaseOrgName : ''
        },
        //获取税码信息
        getTaxCodeListVue() {
            getTaxCodeList({
                taxCode: "",
                taxRate: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            })
        },
        //获取同步状态 
        getSyncStatus(val) {
            var type = this.SYNC_STATUS_PRICE.find(type => type.value === val)
            return type ? type.label : ''
        },
        // 获取税码的名字
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        // 通过工厂code  获取名字
        getFactoryName(code) {
            const factory = this.factoryList.find(
                (factory) => factory.factoryCode === code
            )
            return factory ? factory.factoryDesc : ''
        },
        //获取采购组对应的name
        getProcurementName(code) {
            const procurementName = this.procurementList.find(procurementName => procurementName.positionCode === code)
            return procurementName ? procurementName.realName : ''
        },
        //批量推送sap
        pushSaps(){
            if(this.dataListSelections.length == 0){
                this.$message.warning("请选择数据")
                return
            }
            this.$confirm('当前共选中'+this.dataListSelections.length+'条数据进行批量推送。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const zguidList = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    zguidList.push(this.dataListSelections[index].zguid);
                }
                pushSapBack(zguidList).then(data => {
                    if(data.code === '00'){
                        this.$message.success({
                        message: '推送成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                            this.$emit("refreshDataList")
                        }
                    })
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            })
        },
        //推送sap
        pushSap(row){
          row.syncing = true; // 设置按钮为不可操作状态
          const zguidList = [];
            zguidList.push(row.zguid);
            pushSapBack(zguidList).then(data => {
                 if(data.code === '00'){
                    this.$message.success({
                      message: '推送完成',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                          this.getDataList()
                          this.$emit("refreshDataList")
                      }
                  });
                   setTimeout(() => {
                     row.syncing = false; // 在等待五秒后将当前行的同步状态设置为 false
                   }, 5000); // 5000毫秒即5秒
                 }else{
                      this.$message.error(data.msg);
                      row.syncing = false;
                 }
            }).catch(() => {
              this.$message.error('请求失败');
              row.syncing = false; // 恢复按钮可操作状态
            });
        },
        readAsBinaryString(data) {
            //alert(JSON.stringify(data))
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        // 批量删除
        deleteList(){
            if(this.dataListSelections.length == 0){
                this.$message.warning("请选择数据")
                return
            }
            this.$confirm('当前共选中'+this.dataListSelections.length+'条数据进行批量删除。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const partIdList = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    if(this.dataListSelections[index].choose == 'U'){
                        this.$message.warning("已同步的数据不能删除")
                        return
                    }
                    partIdList.push(this.dataListSelections[index].partId);
                }
                deleteListBack(partIdList).then(data => {
                    if(data.code === '00'){
                        this.$message.success({
                        message: '删除成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                            this.$emit("refreshDataList")
                        }
                    })
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePriceAgreementById({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                                this.$emit("refreshDataList")
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case 0:
                    className = "text-primary"
                    break;
                case 2:
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
        //修改
        updateHandle(row) {
            this.updateVisible = true
            this.$nextTick(() => {
                this.$refs.updateAgreement.init(row, row ? row.id : null, 'edit')
            })
        },
        tableRowClassName({row, rowIndex}) {
           var day = this.difference(row.contractEndDate,Date.now())
            if (day<=30 && day>0) {
                return 'warning-row';
            } else if (day>30 && day<=60) {
                return 'success-row';
            }
            return '';
        },
        // 时间差计算
        difference(beginTime, endTime) {
            var dateBegin = new Date(beginTime);
            var dateEnd = new Date(endTime);
            var dateDiff = dateBegin.getTime() - dateEnd.getTime(); //时间差的毫秒数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
            // var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
            // var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
            //计算相差分钟数
            // var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
            // var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
            //计算相差秒数
            // var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
            // var seconds = Math.round(leave3 / 1000);
            return dayDiff;
        },
        strStart(str) {
            return str.indexOf('PA')
        },
        // 协议状态
        agreementStatusFormat: function (value) {
            // var value = row[column.property]
            if (!value) {
                return ''
            }
            return getLabelByValue(AGREEMENT_STATUS, value)
        },
    }
}
</script>
<style>
  .el-table .warning-row {
    background: #FACD91;
  }

  .el-table .success-row {
    background: #FFFF80;
  }
  .el-table .succ-row {
    background: rgb(6, 245, 6);;
  }
</style>
